export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA1967.c9364a37.jpg";